import {batch, computed, signal} from "@preact/signals-react";
import {isEmpty} from "@ui-seeker/utils";


export const matcherSKUsItems = signal(null)
export const matcherSKUsImageSize = signal(1)
export const isLoadMoreItems = signal(false)
export const matcherSKUDrawerData = signal({})
export const matcherSKUDrawerError = signal({})
export const reloadBrandSkusTrigger = signal(0)
export const matcherSKUImageComparatorModalData = signal({})

// Computed
export const isMatcherSKUsLoading = computed(() => matcherSKUsItems.value === null)
export const matcherSKUsImageSizeValue = computed(() => [150, 200, 250][matcherSKUsImageSize.value])
export const isOpenDrawerMatcherSKU = computed(() => !isEmpty(matcherSKUDrawerData.value))
export const disabledMatcherSKUForm = computed(() => !isEmpty(Object.fromEntries(
	Object.entries(matcherSKUDrawerError.value).filter(([_, value]) => !!value)
)))

// Functions
export const clearMatchersSKUsSignals = () => batch(() => {
	matcherSKUsItems.value = null
	matcherSKUsImageSize.value = 1
	isLoadMoreItems.value = false
	matcherSKUDrawerData.value = {}
	matcherSKUDrawerError.value = {}
	matcherSKUImageComparatorModalData.value = {}
})

export const reloadBrandSkus = () => {
	reloadBrandSkusTrigger.value = reloadBrandSkusTrigger.value + 1
}